import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import HomeEn from './translations/home.en.json';
import HomeEnCan from './translations/home.en.can.json';
import HomeFrCan from './translations/home.fr.can.json';

import SessionRouterEn from './translations/sessionRouter.en.json';
import SessionRouterEnCan from './translations/sessionRouter.en.can.json';
import SessionRouterFrCan from './translations/sessionRouter.fr.can.json';

import SideMenuEn from './translations/sideMenu.en.json';
import SideMenuEnCan from './translations/sideMenu.en.can.json';
import SideMenuFrCan from './translations/sideMenu.fr.can.json';

import SettingsScreenEn from './translations/settingsScreen.en.json';
import SettingsScreenEnCan from './translations/settingsScreen.en.can.json';
import SettingsScreenFrCan from './translations/settingsScreen.fr.can.json';

import LoginScreenEn from './translations/loginScreen.en.json';
import LoginScreenEnCan from './translations/loginScreen.en.can.json';
import LoginScreenFrCan from './translations/loginScreen.fr.can.json';

import PageNotFoundEn from './translations/pageNotFound.en.json';
import PageNotFoundEnCan from './translations/pageNotFound.en.can.json';
import PageNotFoundFrCan from './translations/pageNotFound.fr.can.json';

import CommonEn from './translations/common.en.json';
import CommonEnCan from './translations/common.en.can.json';
import CommonFrCan from './translations/common.fr.can.json';

import InboxAndDocsEn from './translations/inboxAndDocs.en.json';
import InboxAndDocsEnCan from './translations/inboxAndDocs.en.can.json';
import InboxAndDocsFrCan from './translations/inboxAndDocs.fr.can.json';

import MyPetsEn from './translations/myPets.en.json';
import MyPetsEnCan from './translations/myPets.en.can.json';
import MyPetsFrCan from './translations/myPets.fr.can.json';

import EditReimbursementMethodEn
from './translations/editReimbursementMethod.en.json';
import EditReimbursementMethodEnCan
from './translations/editReimbursementMethod.en.can.json';
import EditReimbursementMethodFrCan
from './translations/editReimbursementMethod.fr.can.json';

import InsuranceEn from './translations/insurance.en.json';
import InsuranceEnCan from './translations/insurance.en.can.json';
import InsuranceFrCan from './translations/insurance.fr.can.json';

import ClaimsEn from './translations/claims.en.json';
import ClaimsEnCan from './translations/claims.en.can.json';
import ClaimsFrCan from './translations/claims.fr.can.json';

import FileClaimsEn from './translations/fileClaims.en.json';
import FileClaimsEnCan from './translations/fileClaims.en.can.json';
import FileClaimsFrCan from './translations/fileClaims.fr.can.json';

import FileClaimbotEn from './translations/fileClaimbot.en.json';
import FileClaimbotEnCan from './translations/fileClaimbot.en.can.json';
import FileClaimbotFrCan from './translations/fileClaimbot.fr.can.json';

import FoundLostPetEn from './translations/foundLostPet.en.json';
import FoundLostPetEnCan from './translations/foundLostPet.en.can.json';
import FoundLostPetFrCan from './translations/foundLostPet.fr.can.json';

import GenericErrorEn from './translations/genericError.en.json';
import GenericErrorEnCan from './translations/genericError.en.can.json';
import GenericErrorFrCan from './translations/genericError.fr.can.json';

import PaymentMethodEn from './translations/paymentMethod.en.json';
import PaymentMethodEnCan from './translations/paymentMethod.en.can.json';
import PaymentMethodFrCan from './translations/paymentMethod.fr.can.json';

import ChangeCoverageEn from './translations/changeCoverage.en.json';
import ChangeCoverageEnCan from './translations/changeCoverage.en.can.json';
import ChangeCoverageFrCan from './translations/changeCoverage.fr.can.json';

import MyAccountEn from './translations/myAccountScreen.en.json';
import MyAccountEnCan from './translations/myAccountScreen.en.can.json';
import MyAccountFrCan from './translations/myAccountScreen.fr.can.json';

import MultibrandEn from './translations/multibrand.en.json';
import MultibrandEnCan from './translations/multibrand.en.can.json';
import MultibrandFrCan from './translations/multibrand.fr.can.json';

export const LANGUAGES_FR_CA = 'fr-CA';
export const LANGUAGES_ES_CA = 'en-CA';
export const LANGUAGES_ES_US = 'en-US';

export const CURRENCY_FORMAT_DEFAULT = {
  currency: 'USD',
  key: LANGUAGES_ES_US,
};

// still needed to configure i18next
// but the actual list of languages is retrieved from backend
export const GLOBAL_LANGUAGES = [
  {
    currency: 'USD',
    id: 0,
    key: LANGUAGES_ES_US,
    label: 'English (US)',
  },
  {
    currency: 'CAD',
    id: 1,
    key: LANGUAGES_ES_CA,
    label: 'English (CAN)',
  },
  {
    currency: 'CAD',
    id: 2,
    key: LANGUAGES_FR_CA,
    label: 'Français',
  },
];

const DEFAULT_LANGUAGE_ENG_US = GLOBAL_LANGUAGES[0];

const resources = {
  // English US
  [GLOBAL_LANGUAGES[0].key]: {
    changeCoverage: ChangeCoverageEn,
    claims: ClaimsEn,
    common: CommonEn,
    editReimbursementMethod: EditReimbursementMethodEn,
    fileClaimbot: FileClaimbotEn,
    fileClaims: FileClaimsEn,
    foundLostPet: FoundLostPetEn,
    genericError: GenericErrorEn,
    home: HomeEn,
    inboxAndDocs: InboxAndDocsEn,
    insurance: InsuranceEn,
    loginScreen: LoginScreenEn,
    multibrand: MultibrandEn,
    myAccount: MyAccountEn,
    myPets: MyPetsEn,
    pageNotFound: PageNotFoundEn,
    paymentMethod: PaymentMethodEn,
    sessionRouter: SessionRouterEn,
    settingsScreen: SettingsScreenEn,
    sideMenu: SideMenuEn,
  },
  // English Canadian
  [GLOBAL_LANGUAGES[1].key]: {
    changeCoverage: ChangeCoverageEnCan,
    claims: ClaimsEnCan,
    common: CommonEnCan,
    editReimbursementMethod: EditReimbursementMethodEnCan,
    fileClaimbot: FileClaimbotEnCan,
    fileClaims: FileClaimsEnCan,
    foundLostPet: FoundLostPetEnCan,
    genericError: GenericErrorEnCan,
    home: HomeEnCan,
    inboxAndDocs: InboxAndDocsEnCan,
    insurance: InsuranceEnCan,
    loginScreen: LoginScreenEnCan,
    multibrand: MultibrandEnCan,
    myAccount: MyAccountEnCan,
    myPets: MyPetsEnCan,
    pageNotFound: PageNotFoundEnCan,
    paymentMethod: PaymentMethodEnCan,
    sessionRouter: SessionRouterEnCan,
    settingsScreen: SettingsScreenEnCan,
    sideMenu: SideMenuEnCan,
  },
  // French Canadian
  [GLOBAL_LANGUAGES[2].key]: {
    changeCoverage: ChangeCoverageFrCan,
    claims: ClaimsFrCan,
    common: CommonFrCan,
    editReimbursementMethod: EditReimbursementMethodFrCan,
    fileClaimbot: FileClaimbotFrCan,
    fileClaims: FileClaimsFrCan,
    foundLostPet: FoundLostPetFrCan,
    genericError: GenericErrorFrCan,
    home: HomeFrCan,
    inboxAndDocs: InboxAndDocsFrCan,
    insurance: InsuranceFrCan,
    loginScreen: LoginScreenFrCan,
    multibrand: MultibrandFrCan,
    myAccount: MyAccountFrCan,
    myPets: MyPetsFrCan,
    pageNotFound: PageNotFoundFrCan,
    paymentMethod: PaymentMethodFrCan,
    sessionRouter: SessionRouterFrCan,
    settingsScreen: SettingsScreenFrCan,
    sideMenu: SideMenuFrCan,
  },
};

const options = {
  convertDetectedLanguage: (lng) => {
    // any valid/selectable language
    if (GLOBAL_LANGUAGES.some((lang) => lang.key === lng)) {
      return lng;
    }

    // all other languages
    return DEFAULT_LANGUAGE_ENG_US.key;
  },
  lookupLocalStorage: 'i18nextLng',
  order: ['localStorage', 'navigator'],
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug: false,
    defaultNS: 'home',
    detection: options,
    fallbackLng: DEFAULT_LANGUAGE_ENG_US.key,
    ns: ['common', 'home', 'loginScreen'],
    resources,
  });

export default i18n;
